import { Box, keyframes } from '@mui/material'

// Réplica em React do fundo do site institucional (site/assets/css/site.css):
// gradiente base + malha de linhas azul mascarada + grão de filme + aurora com
// deriva lenta + o anel de órbita girando (assinatura da marca). Usado nas telas
// públicas do app (login e contratação) pra casar com o site.
const GRAIN = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.55'/%3E%3C/svg%3E\")"

const auroraA = keyframes({ from: { transform: 'translate3d(0,0,0) scale(1)' }, to: { transform: 'translate3d(60px,40px,0) scale(1.12)' } })
const auroraB = keyframes({ from: { transform: 'translate3d(0,0,0) scale(1.05)' }, to: { transform: 'translate3d(-70px,30px,0) scale(.92)' } })
const orbitSpin = keyframes({ from: { transform: 'rotate(-24deg) scaleY(.42)' }, to: { transform: 'rotate(336deg) scaleY(.42)' } })

export function BrandBackground() {
  return (
    <Box aria-hidden sx={{ position: 'fixed', inset: 0, zIndex: -1, pointerEvents: 'none', overflow: 'hidden' }}>
      <Box sx={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg,#fff 0%,#fff 40%,#f6f8fc 100%)' }} />
      <Box sx={{
        position: 'absolute', inset: 0,
        backgroundImage: 'linear-gradient(rgba(37,99,235,.05) 1px,transparent 1px),linear-gradient(90deg,rgba(37,99,235,.05) 1px,transparent 1px)',
        backgroundSize: '62px 62px',
        maskImage: 'radial-gradient(120% 80% at 50% -10%,#000 0%,transparent 68%)',
        WebkitMaskImage: 'radial-gradient(120% 80% at 50% -10%,#000 0%,transparent 68%)',
      }} />
      <Box sx={{ position: 'absolute', inset: 0, backgroundImage: GRAIN, backgroundSize: '160px 160px', opacity: 0.035 }} />
      <Box sx={{
        position: 'absolute', width: 620, height: 620, top: -260, left: '4%', borderRadius: '50%', filter: 'blur(90px)',
        background: 'radial-gradient(circle at 30% 30%,rgba(37,99,235,.30),transparent 68%)',
        animation: `${auroraA} 22s ease-in-out infinite alternate`,
        '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
      }} />
      <Box sx={{
        position: 'absolute', width: 540, height: 540, top: -220, right: '3%', borderRadius: '50%', filter: 'blur(90px)',
        background: 'radial-gradient(circle at 60% 40%,rgba(99,102,241,.24),rgba(14,165,233,.15) 55%,transparent 72%)',
        animation: `${auroraB} 26s ease-in-out infinite alternate`,
        '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
      }} />
      <Box sx={{
        position: 'absolute', width: 1100, height: 1100, right: -420, top: -360,
        border: '1px solid rgba(37,99,235,.14)', borderRadius: '50%',
        transform: 'rotate(-24deg) scaleY(.42)',
        boxShadow: '0 0 0 44px rgba(37,99,235,.05),0 0 0 130px rgba(37,99,235,.03)',
        animation: `${orbitSpin} 90s linear infinite`,
        '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
      }} />
    </Box>
  )
}
